import { useSelector } from 'react-redux';
import { PostStore } from './postReducer';
import { Store } from 'types/Store';

export function usePost(): PostStore {
  return useSelector((state: Store) => state.post);
}
